import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function ApproveStockCountDialog({
  open,
  loading = false,
  disabled = false,
  error = "",
  onClose,
  onConfirm,
}) {
  function handleClose() {
    if (!loading) onClose?.();
  }

  return (
    <Dialog
      open={Boolean(open)}
      onClose={loading ? undefined : handleClose}
      PaperProps={{ sx: { borderRadius: "24px", maxWidth: 480 } }}
    >
      <DialogTitle sx={{ fontWeight: 800, color: "primary.900" }}>
        Aprobar e integrar conteo
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: "neutral.700", fontSize: 14, fontWeight: 650 }}>
          Se integrarán los ajustes calculados al stock global de la empresa. Esta acción
          no se puede deshacer.
        </Typography>
        {error ? (
          <Typography sx={{ mt: 1.5, color: "error.main", fontSize: 13, fontWeight: 700 }}>
            {error}
          </Typography>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button
          type="button"
          onClick={handleClose}
          disabled={loading}
          sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
        >
          Cancelar
        </Button>
        <Button
          type="button"
          variant="contained"
          disabled={loading || disabled}
          onClick={onConfirm}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
          sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
        >
          {loading ? "Integrando..." : "Aprobar e integrar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
